import React from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

import { SuccessAlert, WarningAlert } from 'components/ui/Alert';
import { useRunPayrollDataContext } from '../contexts/RunPayrollDataContext';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

const InfoDisplay = () => {
  const data = useRunPayrollDataContext();
  const isRXIntegrated = useSelector(loggedInUserSelectors.isOrgRXIntegrated);
  const currentOrganization = useSelector(loggedInUserSelectors.currentOrganization);
  const autoExecutePayroll = currentOrganization?.autoExecutePayroll;

  if (!data) {
    return null;
  }

  const {
    isLocalOrRXBalanceSufficient,
    isRequiredAmountAvailable,
    isPayrollFinalized,
    isPayrollProcessedForAllUsers,
    payrollMonth
  } = data;

  const finalizedMessage = isPayrollProcessedForAllUsers 
    ? `The ${format(new Date(payrollMonth as string), 'MMMM yyyy')} payroll for all employees has been executed.`
    : 'Your payroll has been finalized. ';

  return (
    <>
      {isRequiredAmountAvailable === false ? (
        <WarningAlert className="mb-10">
          <span>
            The required payroll amount couldn&apos;t be computed. Please re-finalize the payroll
            - if the issue persists, contact support.
          </span>
        </WarningAlert>
      ) : !isLocalOrRXBalanceSufficient ? (
        isRXIntegrated ? (
          <WarningAlert className="mb-10">
            <span>
              XPayroll cannot process this payroll till you have sufficient balance. Please load
              funds to your RazorpayX account asap.
            </span>
          </WarningAlert>
        ) : (
          <WarningAlert className="mb-10">
            <span>
              XPayroll cannot process this payroll till you have sufficient balance. Please{' '}
              <a href="/moneyTransfer" target="_blank">
                transfer funds
              </a>{' '}
              asap.
            </span>
          </WarningAlert>
        )
      ) : (
        autoExecutePayroll && (
          <SuccessAlert className="mb-10">
            Your payroll is on auto-pilot and will be processed automatically.
          </SuccessAlert>
        )
      )}

      {isPayrollFinalized && (
        <SuccessAlert className="mb-10">{finalizedMessage}</SuccessAlert>
      )}
    </>
  );
};

export default InfoDisplay;
